// extracted by mini-css-extract-plugin
export default {"toggle":"S7wkcHLA","input":"xnlhOvKt","switch":"CUATkGgv","label":"ndmOHbnm"};